import { PrescriptionPadStep } from '@/components/Patient/components/PrescriptionPad/PrescriptionPad.types';
import type {
  PrescriptionHistoryState,
  PrescriptionPadRules,
  PrescriptionPadState,
  PrescriptionSubmitState,
} from './types';

export const initialPrescriptionPadReviewActions = [
  {
    id: 1,
    label:
      'I confirm that I have accessed all relevant real-time prescribing services in any state that may be relevant to this patient.',
    checked: false,
  },
  {
    id: 2,
    label: 'I have documented thorough clinical notes for this consultation.',
    checked: false,
  },
];

export const initialPrescriptionHistoryState: PrescriptionHistoryState = {
  itemsToReissue: [],
  itemsToCancel: [],
  previousItems: [],
};

export const initialPrescriptionPadState: PrescriptionPadState = {
  medicationPadItems: [],
  devicePadItems: [],
  step: PrescriptionPadStep.Create,
  actions: initialPrescriptionPadReviewActions,
  dispenseNote: '',
  showCancellation: false,
  dispenseLimits: {},
};

/** Title of a pad item alert that blocks review until the prescriber fixes the item */
export const ALERT_ACTION_REQUIRED_TITLE = 'Action Required:';

export const initialPrescriptionPadRules: PrescriptionPadRules = {
  enableDispenseLimits: false,
  requireMaxDailyDose: false,
};

export const initialPrescriptionSubmitState: PrescriptionSubmitState = {
  isPostingPrescription: false,
  isCancellingPrescription: false,
  showPrescribeStateError: false,
};

export const initialStatePrescriptionAssistantSlice = {
  prescriptionHistory: initialPrescriptionHistoryState,
  prescriptionPad: initialPrescriptionPadState,
  prescriptionPadRules: initialPrescriptionPadRules,
  prescriptionSubmitState: initialPrescriptionSubmitState,
};

// Create a mutable object to hold only the necessary reissue status properties
export const reissueStatusStore: {
  current: {
    productId?: number;
    isOutOfStock?: boolean;
    isDiscontinued?: boolean;
    isActive?: boolean;
    isUnavailable?: boolean;
  } | null;
} = { current: null };
